import { Action } from '@ngrx/store';
import { Geofence } from '@polaris-customerweb/sharedcomponents.user-content';

export const GeofenceAction = {
    createGeofence: '[geofence] create geofence',
    deleteGeofence: '[geofence] delete geofence',
    forceGeofenceRefresh: '[geofence] refresh on next pull',
    setActiveGeofence: '[geofence] set active geofence',
    setEditableGeofence: '[geofence] set editable geofence',
    setGeofences: '[geofence] set geofences',
    setIsGeofenceEditing: '[geofence] set is geofence editing',
    toggleActiveGeofence: '[geofence] toggle active geofence',
    updateGeofence: '[geofence] update geofence',
};

export class CreateGeofence implements Action {
    type = GeofenceAction.createGeofence;
    constructor(public geofence: Geofence) {}
}

export class DeleteGeofence implements Action {
    type = GeofenceAction.deleteGeofence;
    constructor(public geofenceId: string) {}
}

export class ForceGeofenceRefresh implements Action {
    type = GeofenceAction.forceGeofenceRefresh;
    constructor(public forceRefresh: boolean) {}
}

export class SetActiveGeofence implements Action {
    type = GeofenceAction.setActiveGeofence;
    constructor(public geofence: Geofence | undefined) {}
}

export class SetEditableGeofence implements Action {
    type = GeofenceAction.setEditableGeofence;
    constructor(public geofence: Geofence | undefined) {}
}

export class SetIsGeofenceEditing implements Action {
    type = GeofenceAction.setIsGeofenceEditing;
    constructor(public isEditing: boolean) {}
}

export class SetGeofences implements Action {
    type = GeofenceAction.setGeofences;
    constructor(public geofences: Geofence[]) {}
}

export class ToggleActiveGeofence implements Action {
    type = GeofenceAction.toggleActiveGeofence;
    constructor(public geofence: Geofence | undefined) {}
}

export class UpdateGeofence implements Action {
    type = GeofenceAction.updateGeofence;
    constructor(public geofence: Geofence) {}
}
